module.exports = __webpack_public_path__ + "img/tut_img_1.9a26668f.svg";